
export function getDate(date: Date | string) {
    var _date = new Date(date);

    let dd = _date.getDate();
    let d = dd < 10 ? "0" + dd : dd;

    let mm = (_date.getMonth() + 1);
    let m = mm < 10 ? "0" + mm : mm;

    var mimi = _date.getMinutes();
    let mi = mimi < 10 ? "0" + mimi : mimi;

    var hh = _date.getHours();
    let h = hh < 10 ? "0" + hh : hh;

    return `${d}/${m}/${_date.getFullYear()}`;
}

export function getDateTime(date: Date | string) {
    var _date = new Date(date);

    let dd = _date.getDate();
    let d = dd < 10 ? "0" + dd : dd;

    let mm = (_date.getMonth() + 1);
    let m = mm < 10 ? "0" + mm : mm;

    var s = _date.getSeconds();
    let ss = s < 10 ? "0" + s : s;

    var mimi = _date.getMinutes();
    let mi = mimi < 10 ? "0" + mimi : mimi;

    var hh = _date.getHours();
    let h = hh < 10 ? "0" + hh : hh;

    return `${d}/${m}/${_date.getFullYear()} ${h}:${mi}:${ss}`;
}

export function getToday() {
    let newDate = new Date();
    return new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
}

export const getTodayDateString = () => {
    let d = new Date();
    d.setDate(d.getDate());
    return getDateString(d);
}

export const getTwoWeeksAheadDateString = () => {
    let d = new Date();
    d.setDate(d.getDate() + 14);
    return getDateString(d);
}

export function getFutureDate(startDate: string, days: number) {
    let date = new Date(startDate);
    date.setDate(date.getDate() + days);

    const dd = date.getDate();
    const mm = date.getMonth() + 1;
    const yy = date.getFullYear();
    let d = dd < 10 ? "0" + dd : dd;
    let m = mm < 10 ? "0" + mm : mm;

    const formattedDate = `${d}/${m}/${yy}`;

    return formattedDate;
}

export const getDateString = (date: Date) => {
    date = new Date(date);
    let yy = date.getFullYear();
    let mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
    let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return `${yy}-${mm}-${dd}`;
}

export const getStringDateNormalized = (dateString?: string, withTime?: boolean) => {
    if (!dateString) return "";
    let date = new Date(dateString);
    return getDateStringNormalized(date, withTime);
}
export const getDateStringNormalized = (date: Date, withTime?: boolean) => {
    if (!date) return;

    if (date instanceof Date !== true) {
        date = new Date(date);
    }

    let yy = date.getFullYear();
    let mm = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
    let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    var _return = `${dd}/${mm}/${yy}`;

    if (withTime) {
        let hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let MM = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        return `${_return} ${hh}:${MM}`;
    }
    return _return;
}
